import { render, staticRenderFns } from "./UnitOfMeasureViewGlobalUnits.vue?vue&type=template&id=794603b6"
import script from "./UnitOfMeasureViewGlobalUnits.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasureViewGlobalUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports